import { SimpleScrollView, SimpleScrollViewItem } from 'common/components/simple-scroll-view';
import { SimpleScrollViewProps } from 'common/components/simple-scroll-view/SimpleScrollView';
import { Category } from 'common/constants/data-types';
import { isEmpty } from 'lodash';
import React, { useCallback } from 'react';
import './CategoryHorizontalList.styles';

interface CategoryHorizontalListProps extends SimpleScrollViewProps {
  category: Category;
  onMainCategorySelect?: (category: Category) => void;
  onSubcategorySelect?: (mainCategory: Category, category: Category) => void;
  getFocusKey?: (category: Category, index: number) => string;
}

function CategoryHorizontalList(props: CategoryHorizontalListProps) {
  const subcategories = props.category.subcategories ?? [];

  const onBack = useCallback(
    (last?: boolean) => {
      props.onBack?.(last);
      // Always handle back navigation
      return true;
    },
    [props.onBack]
  );

  return (
    <SimpleScrollView
      className="category-horizontal-list"
      saveLastFocused={false}
      focusBoundaryDirections={['right']}
      {...props}
      onBack={onBack}
    >
      {[
        <SimpleScrollViewItem
          key={`category-item-${props.category.id}`}
          className="main-category-horizontal-list-item"
          onEnterPress={() => props.onMainCategorySelect?.(props.category)}
          onClick={() => props.onMainCategorySelect?.(props.category)}
          focusKey={props.getFocusKey?.(props.category, 0)}
          testId={`category-horizontal-list-main-item-${props.category.id}`}
        >
          <span className="title">{props.category.name}</span>
        </SimpleScrollViewItem>,
        ...(!isEmpty(subcategories)
          ? [
              <span
                key="category-horizontal-list-item-separator"
                className="category-horizontal-list-item-separator"
              >
                ·
              </span>
            ]
          : []),
        ...subcategories.map((category, index) => (
          <SimpleScrollViewItem
            key={`category-item-${category.id}`}
            className="category-horizontal-list-item"
            onEnterPress={() => props.onSubcategorySelect?.(props.category, category)}
            onClick={() => props.onSubcategorySelect?.(props.category, category)}
            focusKey={props.getFocusKey?.(category, index + 1)}
            testId={`category-horizontal-list-sub-item-${category.id}`}
          >
            <span className="title">{category.name}</span>
          </SimpleScrollViewItem>
        ))
      ]}
    </SimpleScrollView>
  );
}

export default React.memo(CategoryHorizontalList);
